<template>
  <div
    class="mt-5 flex w-full flex-row rounded-lg bg-orange-400 p-4 text-sm text-white shadow md:grid-cols-3 md:divide-x md:divide-y-0"
    v-if="fondsStore.notTradable"
  >
    <ExclamationCircleIcon class="mr-2 h-5 w-5 bg-orange-400 text-white" aria-hidden="true" />
    Dieser Fonds ist bei der ausgewählten Bank leider nicht handelbar. Bitte wählen Sie eine andere
    Bank.
  </div>

  <div v-if="fondsStore.selectedFonds !== null">
    <dl
      :class="[fondsStore.notTradable ? 'opacity-40' : '']"
      class="mt-5 grid grid-cols-1 divide-y divide-gray-200 overflow-hidden rounded-lg bg-white shadow md:grid-cols-3 md:divide-x md:divide-y-0"
    >
      <div v-for="item in stats" :key="item.name" class="px-4 py-5 sm:p-6">
        <dt class="text-base font-normal text-gray-900">{{ item.name }}</dt>
        <dd class="mt-1 flex items-baseline justify-between md:block lg:flex">
          <div class="flex items-baseline text-2xl font-semibold text-orange-400">
            {{ item.stat.value }}
            <span class="ml-2 text-sm font-medium text-gray-500"> {{ item.previousStat }}</span>
          </div>

          <div
            v-if="['increase', 'decrease'].includes(item.changeType)"
            :class="[
              item.changeType === 'increase'
                ? 'bg-green-100 text-green-800'
                : 'bg-red-100 text-red-800',
              'inline-flex items-baseline rounded-full px-2.5 py-0.5 text-sm font-medium md:mt-2 lg:mt-0'
            ]"
          >
            <span class="sr-only">
              {{ item.changeType === 'increase' ? 'Increased' : 'Decreased' }} by
            </span>
            {{ item.change.value }}
          </div>
        </dd>
      </div>
    </dl>
  </div>
</template>

<script setup lang="ts">
import { useFondsStore } from '@/stores/fonds'
import { computed } from 'vue'
import { ExclamationCircleIcon } from '@heroicons/vue/20/solid'
import { moneyFormat, numberFormat } from '@/filters/toCurrency.filter'

const fondsStore = useFondsStore()

// const courtage = computed(() => fondsStore.getCourtage())
const stats = [
  {
    name: 'Ausgabeaufschlag (Agio)',
    stat: computed(() =>
      moneyFormat((fondsStore.defaultInvest / 100) * (fondsStore.getCourtage()?.agio || 0))
    ),
    previousStat: '100% Rabatt',
    change: computed(() => numberFormat(fondsStore.getCourtage()?.agio || 0, 2) + '%'),
    changeType: 'increase'
  },
  {
    name: 'Bestandsprovision',
    stat: computed(() =>
      moneyFormat(
        (Math.round(fondsStore.getCourtage()?.portfolioCommission || 0) / 10000) *
          fondsStore.defaultInvest
      )
    ),
    previousStat: 'jährlich',
    change: computed(
      () => numberFormat((fondsStore.getCourtage()?.portfolioCommission || 0) / 100, 2) + '%'
    ),
    changeType: 'increase'
  },
  {
    name: 'Anlagebetrag (Beispiel)',
    stat: computed(() => moneyFormat(fondsStore.defaultInvest)),
    previousStat: 'einmalig',
    change: '',
    changeType: ''
  }
]
</script>
